import styled from "styled-components";

export const Input = styled.input.attrs({
    className:"w-full focus:outline-[#103734] my-2 border rounded-full bg-transparent px-4 py-2 border-[#CDD1CC]"
})`

`